import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
function Home() {
  let navigate = useNavigate();
  useEffect(() => {
    navigate('/user/login');
    // <Redirect to="/dashboard" />;
    // window.location.re('/dashboard');
  }, []);
  return <>{/* <Redirect to="/dashboard" /> */}</>;
}

export default Home;
